import React, { useRef, useState } from "react";
import "./contact.scss";
import emailjs from "@emailjs/browser";

// service_d7gzztk
//template_mrrdcvm
//nqPb4vZYGxB9hqZCG
export default function Contact() {
    const formRef = useRef();
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        setForm({
            ...form,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        emailjs
            .send(
                "service_d7gzztk",
                "template_mrrdcvm",
                {
                    from_name: form.name,
                    to_name: "Khursheed Ahmed",
                    from_email: form.email,
                    to_email: "khurshedd6577@gmail.com",
                    message: form.message,
                },
                'nqPb4vZYGxB9hqZCG'
            )
            .then(
                () => {
                    setLoading(false);
                    alert("Thank you. I will get back to you as soon as possible.");

                    setForm({
                        name: "",
                        email: "",
                        message: "",
                    })
                },
                (error) => {
                    setLoading(false);
                    console.error(error);

                    alert("Ahh, something went wrong. Please try again.");
                }
            );
    };

    return (
        <div className="contact" id="contact">
            <div className="left">
                <img src="assets/shake.svg" alt="" />
            </div>
            <div className="right">
                <h2>Contact.</h2>
                <form ref={formRef}
                    onSubmit={handleSubmit}>
                    <input
                        type='text'
                        name='name'
                        value={form.name}
                        onChange={handleChange}
                        placeholder="What's your good name?"
                    // className="right"
                    />
                    <input type='email'
                        name='email'
                        value={form.email}
                        onChange={handleChange} placeholder="Enter your mail" />
                    <textarea rows={7}
                        name='message'
                        value={form.message}
                        onChange={handleChange}
                        placeholder='What you want to say?'
                    ></textarea>
                    <button type="submit">{loading ? "Sending..." : "Send"}</button>
                </form>
            </div>
        </div>

    );
}